/* global mixpanel */
import _ from 'lodash'

export function loyaltyStart () {
  mixpanel.track('Loyalty Start')
}

export function loyaltyVideoStart () {
  mixpanel.track('Loyalty Video')
}

export function createProgramShowProgramType () {
  mixpanel.track('Loyalty Create 1. Program Type')
}

export function createProgramShowPointRule () {
  mixpanel.track('Loyalty Create 2. Point Rule')
}

export function createProgramShowReward () {
  mixpanel.track('Loyalty Create 3. Reward')
}

export function createProgramShowConfiguration () {
  mixpanel.track('Loyalty Create 4. Configuration')
}

export function createProgramShowReview () {
  mixpanel.track('Loyalty Create 5. Review')
}

export function createLoyalty (data) {
  mixpanel.track('Loyalty Create 7. Subscribe and Submit', loyaltyProgramInfoToMixPanelInfo(data))
}

export function createLoyaltySuccess () {
  mixpanel.track('Loyalty Create 8.1 Success')
}

export function createLoyaltyFail (displayErrorMessage, error) {
  mixpanel.track('Loyalty Create 8.1 Failed', {
    'Error Message Display': displayErrorMessage,
    'Error Message Detail': error
  })
}

function loyaltyProgramInfoToMixPanelInfo (programInfo) {
  let rewards = _.map(programInfo.rewards, (reward) => {
    return {
      'Reward Type': 'Discount of Total Sale',
      'Redeem Points': reward.redeem_point,
      'Discount Amount': reward.discount_type === 'percentage' ? reward.discount + '%' : 'Rp. ' + reward.discount,
      'Discount For': 'Total Sale'
    }
  })

  return {
    'Program Type': 'Rp X = Y Point',
    'Transaction Value': programInfo.earning_rule.amount,
    'Transaction Point Amount': programInfo.earning_rule.point,
    'New Member Point Amount': programInfo.new_member_point,
    'Rewards': rewards,
    'Send Validation Code': programInfo.is_sent_validation_code
  }
}

//* ***************  MANAGE EXISTING LOYALTY *************************

export function showManageLoyalty () {
  mixpanel.track('Loyalty Manage')
}

export function editProgramStart () {
  mixpanel.track('Loyalty Edit 1. Start')
}

export function resetProgramStart () {
  mixpanel.track('Loyalty Reset 1. Start')
}

export function reactivateLoyalty (data) {
  mixpanel.track('Loyalty Reactivate', loyaltyProgramInfoToMixPanelInfo(data))
}

export function deactivateLoyalty (data) {
  mixpanel.track('Loyalty Deactivate', loyaltyProgramInfoToMixPanelInfo(data))
}

export function resetLoyalty (data) {
  mixpanel.track('Loyalty Reset 2. Submit', loyaltyProgramInfoToMixPanelInfo(data))
}

export function editLoyalty (data) {
  mixpanel.track('Loyalty Edit 2. Submit', loyaltyProgramInfoToMixPanelInfo(data))
}

export function knowledgeCenterLinkClick () {
  mixpanel.track('Loyalty Knowledge Center')
}

export function loyaltyBlogLinkClick () {
  mixpanel.track('Loyalty Blog')
}



// WEBPACK FOOTER //
// ./app/mixpanel/customers/loyalty.js